import state from "./state";
import getters from "./getters";
import mutations from "./mutations";
import actions from "./actions";
import {deviceDetectionStore} from "./device-detection";
import {appStateStore} from "./app-state";
import { nascarDataStateStore } from "./nascar-data-state";
import {failPermissionsStore} from "./fail-permissions";

export const store = {
  state: {
    ...state,
    ...deviceDetectionStore.state,
    ...appStateStore.state,
    ...failPermissionsStore.state,
    ...nascarDataStateStore.state
  },
  getters: {
    ...getters,
    ...deviceDetectionStore.getters,
    ...appStateStore.getters,
    ...failPermissionsStore.getters,
    ...nascarDataStateStore.getters
  },
  mutations: {
    ...mutations,
    ...deviceDetectionStore.mutations,
    ...appStateStore.mutations,
    ...failPermissionsStore.mutations,
    ...nascarDataStateStore.mutations
  },
  actions: {
    ...actions,
    ...deviceDetectionStore.actions,
    ...appStateStore.actions,
    ...failPermissionsStore.actions
  },
};
